<template>
  <div class="modal-header">
    <IconWrapper v-if="!store.state.modal.loading && !headerProps?.isCloseIconHidden" class="close-x" name="closeIcon" @click.stop="emit('close-action')" />
    <div v-if="headerProps">
      <div class="default-container">
        <img :src="headerProps.icon">
        <div class="text-container">
          <div v-if="headerProps.text" class="text" :style="headerProps.textStyle">
            {{ headerProps.text }}
          </div>
          <div v-if="headerProps.textSecondary" class="sub-text" :style="headerProps.textSecondaryStyle">
            {{ headerProps.textSecondary }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { CustomModalProps } from '@/interfaces'
import { IconWrapper } from '@/components/common'

const store = useStore()
defineProps<CustomModalProps>()
const emit = defineEmits(['close-action'])
</script>

<style scoped>
.modal-header {
  .close-x {
    position: absolute;
    right: 16px;
    top: 24px;
    cursor: pointer;
  }
  .default-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    .text-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
      max-width: 396px;

      .text {
        font-weight: 800;
        font-size: 21px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-wrap: nowrap;
      }

      .sub-text {
        text-align: center;
        color: #8a898c;
      }
    }
  }
}
</style>
